export const BOOKS = [
  {
    id: "creating-a-life-that-matters",
    title: "Creating a Life That Matters",
    author: "Rabbi Manis Friedman with Rivka Goldstein",
    year: "2023",
    level: "Meaning & purpose",
    tone: "#7A5C3E",
    url: "https://www.amazon.com/Creating-Life-that-Matters-Meaning/dp/0986277053",
    description:
      "How to live and love with meaning and purpose. A warm, practical guide — drawn from Torah wisdom but written for everyone — to the questions underneath daily life: what am I here for, how do I love well, how do I face loss. A natural companion to the Seven Laws for anyone asking why the small choices matter.",
  },
  {
    id: "on-purpose",
    title: "On Purpose",
    author: "Rabbi Mendel Kalmenson",
    year: "2024",
    level: "Meaning & purpose",
    tone: "#4F6B5E",
    url: "https://www.amazon.com/dp/0826690157",
    description:
      "Practical wisdom for designing a life of purpose, inspired by the life and teachings of the Lubavitcher Rebbe. Short, clear chapters on finding your unique mission and acting on it — written for anyone, of any background, who senses that their life is meant to count for something.",
  },
  {
    id: "letters-for-life",
    title: "Letters for Life",
    author: "Rabbi Levi Y. Shmotkin · from the letters of the Lubavitcher Rebbe",
    year: "2024",
    level: "Emotional wellness",
    tone: "#8C6A4F",
    url: "https://www.amazon.com/Letters-Life-Guidance-Emotional-Lubavitcher/dp/0826690149",
    description:
      "Guidance for emotional wellness drawn from the Rebbe's private correspondence — twelve themes on anxiety, self-worth, resilience, relationships and finding steadiness in hard times. Gentle, deeply practical, and written for any reader looking for a wiser way to carry the ordinary weight of life.",
  },
  {
    id: "conversations-with-my-rabbi",
    title: "Conversations with My Rabbi",
    author: "Nikki Goldstein & Rabbi Eli Schlanger",
    year: "2026",
    level: "Timeless teachings",
    tone: "#5A4E7A",
    url: "https://www.amazon.com/s?k=9780063573109",
    description:
      "Timeless teachings for a fractured world. A record of the mentorship between a seeker and her rabbi — Rabbi Eli Schlanger of Chabad Bondi, whose life was taken in the December 2025 Bondi Beach attack. Honest, warm conversations about faith, doubt, kindness and purpose that any reader can take to heart.",
  },
  {
    id: "seven-gates",
    title: "Seven Gates of Righteous Knowledge",
    author: "Rabbi Moshe Weiner & Dr. Michael Schulman",
    year: "2015",
    level: "Spiritual foundations",
    tone: "#B8860B",
    url: "https://www.amazon.com/Seven-Gates-Righteous-Knowledge-Spiritual/dp/099835340X",
    description:
      "A guide to the spiritual principles behind the Noahide code — faith, prayer, Divine providence, the soul — drawn from classical Jewish sources.",
  },
  {
    id: "divine-code",
    title: "The Divine Code",
    author: "Rabbi Moshe Weiner",
    year: "4th ed., 2023",
    level: "Comprehensive",
    tone: "#8B3A2F",
    description:
      "The most thorough halachic guide to the Noahide commandments available in English, with approbations from leading rabbinic authorities. Covers each of the seven laws in detail, with practical rulings for modern life.",
  },
  {
    id: "path-righteous-gentile",
    title: "The Path of the Righteous Gentile",
    author: "Chaim Clorfene & Yakov Rogalsky",
    year: "1987",
    level: "Introductory",
    tone: "#C86D44",
    description:
      "A classic, accessible introduction to the Seven Laws and their spiritual background. An excellent first book for anyone beginning to explore the Noahide path.",
  },
  {
    id: "rainbow-covenant",
    title: "The Rainbow Covenant",
    author: "Michael Ellias Dallen",
    year: "2003",
    level: "Introductory",
    tone: "#5B6B4A",
    description:
      "Torah and the Seven Universal Laws explored thematically, with an emphasis on their relevance to Western civilisation and the individual seeker.",
  },
  {
    id: "to-perfect-the-world",
    title: "To Perfect the World",
    author: "Rabbi Yehoishophot Oliver",
    year: "2015",
    level: "Historical & inspirational",
    tone: "#3F5B73",
    description:
      "The Lubavitcher Rebbe's call to teach the Noahide code to all mankind, with sources and reflections on why this mission matters for the world's future.",
  },
  {
    id: "mishneh-torah",
    title: "Mishneh Torah, Laws of Kings 8–10",
    author: "Rambam (Maimonides)",
    year: "12th century",
    level: "Primary source",
    tone: "#1C1917",
    description:
      "The classical codification of the Noahide laws. Freely available in Hebrew and English on Sefaria. Three short chapters that every student should read in the original.",
  },
];

export const ORGANIZATIONS = [
  {
    id: "asknoah",
    name: "AskNoah International",
    url: "https://asknoah.org",
    description:
      "Rabbinic guidance, online classes and a vast archive of answered questions for Noahides worldwide. Publisher of The Divine Code.",
  },
  {
    id: "noahide-academy",
    name: "Noahide Academy of Jerusalem",
    url: "https://www.noahide-academy.com",
    description:
      "Structured online courses in Noahide law, Torah and Jewish thought, with the option of formal certification and community.",
  },
  {
    id: "noahide-world-center",
    name: "Noahide World Center",
    url: "https://noahideworldcenter.org",
    description:
      "Based in Jerusalem, offering teaching, community-building and resources for Noahides across the globe.",
  },
  {
    id: "sefaria",
    name: "Sefaria",
    url: "https://www.sefaria.org",
    description:
      "A free digital library of Jewish texts — the Torah, Talmud, Rambam and more — in Hebrew with English translation. Read the primary sources yourself.",
  },
  {
    id: "chabad",
    name: "Chabad.org — Noahide Resources",
    url: "https://www.chabad.org",
    description:
      "Articles, videos and a worldwide network of centres where sincere gentiles are welcome to learn.",
  },
];
